import Web3 from "web3";
const web3Instance = new Web3(window.ethereum);

export { Web3, web3Instance }
